import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      gap: '10px'
    },
    carousel: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '10px'
    },
    text: {
      padding: '5px 10px 5px 10px',
      width: 'fit-content',
      color: palette.text.secondary,
      borderRadius: palette.borderRadius.default,
      fontFamily: 'Montserrat',
      fontWeight: 700,
      marginTop: '5px',
      fontSize: '0.9rem',
      background: palette.background.underBox
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
